import api from "../../index";

export const GetEmailRulesApi = (params) => api.get(`RuleMaster/GetEmailRules?${params}`);

export const ActiveInActiveEmailRuleApi = (queryString) =>
  api.patch(`RuleMaster/Active-InActive-EmailRule?${queryString}`);

export const CreateEmailRulesApi = (body) => api.post("RuleMaster/CreateEmailRules", body);

export const UpdateEmailRuleApi = (body) => api.put("RuleMaster/UpdateEmailRule", body);
